<!--
 * @Description: 用户管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-25 13:14:40
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-11-19 10:38:43
 -->
<template>
  <div class="userMana">
    <div class="searchContainer">
      <div class="searchItem">
        <span class="searchTitle">用户名：</span>
        <el-input v-model="searchUserName" placeholder="请输入用户名"></el-input>
      </div>
      <el-button class="searchButton" type="primary" round @click="search">查询</el-button>
    </div>
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">用户管理</div>
        <div class="handleArea">
          <el-button class="addButton" type="danger" round @click="addUser">新增</el-button>
        </div>
      </div>
      <div class="list">
        <el-table
          :data="listData">
          <el-table-column
            prop="username"
            label="用户名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="realname"
            label="姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="gender"
            label="性别">
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            label="电话">
          </el-table-column>
          <el-table-column
            align="center"
            v-slot="{row: { state }}"
            label="用户状态">
            <div :class="state === '2' ? 'abnormal' : 'normal'">
              {{state === '2' ? '禁用' : '正常'}}
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            width="230"
            v-slot="{row}"
            label="分配管理">
            <div class="distributionHandle">
              <span v-if="userType === '0'" class="distribution" @click='distributionPlatform(row)'>平台部门</span>
              <span class="distribution" @click='distributionRoles(row)'>角色</span>
              <!-- <span class="distribution" @click='distributionResources(row)'>资源</span> -->
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            width="300"
            v-slot="{row}"
            label="操作">
            <div class="handle">
              <span class="detail" @click='showDetail(row)'>详情</span>
              <span class="modify" @click='modifyUser(row)'>编辑</span>
              <span class="modifyPassword" @click='modifyPassword(row)'>密码修改</span>
              <span class="distribution" @click='customAttribute(row)'>自定义字段</span>
              <span class="delete" @click='deleteUser(row)'>删除</span>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <BasePagination
          :total="total"
          :page-size="pageSize"
          :current-page="pageIndex"
          background
          @pagination="currentChange"
        />
      </div>
    </div>
    <!-- 新增用户 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="userDialogClosed"
      :title="addUserDialogTitle"
      :visible.sync="addUserDialogVisible">
      <div class="content">
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>用户名：</span>
          <el-input v-model="username" :maxlength='18' :disabled="dialogType === 'detail' || dialogType === 'modify'" placeholder="请输入用户名"></el-input>
        </div>
        <div class="userInfoItem" v-if="dialogType === 'add'">
          <span class="title"><span class="required">*</span>密码：</span>
          <el-input type="password" :maxlength='30' :disabled="dialogType === 'detail'" :show-password="showPassword" v-model="password" placeholder="请输入密码"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>姓名：</span>
          <el-input v-model="realname" :maxlength='18' :disabled="dialogType === 'detail'" placeholder="请输入姓名"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>性别：</span>
          <el-select v-model="gender" :disabled="dialogType === 'detail'" placeholder="请选择性别">
            <el-option
              v-for="item in genderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">手机号：</span>
          <el-input :maxlength="11" :disabled="dialogType === 'detail'" v-model="mobile" placeholder="请输入手机号"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>账号状态：</span>
          <el-select v-model="state" :disabled="dialogType === 'detail'" placeholder="请选择账号状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>账号类型：</span>
          <el-select v-model="type" :disabled="dialogType === 'detail'" placeholder="请选择账号类型">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- v-if="userType === '0'" -->
        <div class="userInfoItem" v-if="userType !== '0'">
          <span class="title"><span class="required">*</span>平台部门：</span>
          <el-cascader
            :options="platformDept"
            v-model="platformPid"
            :props="{ value: 'id', label: 'name', children: 'childs', emitPath: false, checkStrictly: true }" />
        </div>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增用户 弹框 end -->

    <!-- 修改密码弹框  start -->
    <el-dialog
      class="modifyPasswordDialog"
      @closed="modifyPasswordDialogClosed"
      title="修改密码"
      :visible.sync="modifyPasswordDialogVisible">
      <div class="content">
        <span class="newPwdTitle">新密码：</span>
        <el-input v-model="newPassword" placeholder="请输入新密码"></el-input>
        <div class="handleArea">
          <el-button type="danger" size="medium" @click="cancelModifyPassword">取消</el-button>
          <el-button type="primary" size="medium" @click="confirmModifyPassword">修改</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 修改密码弹框  end -->
    <!-- 分配平台弹框 start -->
    <el-dialog
      class="distributionPlatformDialog"
      @closed="distributionPlatformDialogClosed"
      title="分配平台"
      :visible.sync="distributionPlatformDialogVisible">
      <div class="content">
        <!-- <span class="title">选择平台：</span>
        <el-select v-model="selectedPlatform" multiple @change="selectedPlatformChange" placeholder="请选择要分配的用户">
          <el-option
            v-for="item in platformsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->

        <div class="items" v-for="(item, index) in allPlatformAndDeptOptions" :key="index">
          <div class="platformName">
            <i class="el-icon-s-platform"></i>
            {{item.name}}
          </div>
          <el-cascader
            :options="item.depts"
            v-model="selectedPlatformAndDept[index].dept"
            @change="(val) => {selectedPlatformAndDeptChange(val, index, item.pid)}"
            :props="{ value: 'id', label: 'name', children: 'childs', checkStrictly: true }"
            clearable></el-cascader>
        </div>
      </div>
      <div class="handleBtn">
        <el-button size="small" type="primary" @click="confirmDistributionPlatform">确认</el-button>
        <el-button size="small" type="danger" @click="cancelDistributionPlatform">取消</el-button>
      </div>
    </el-dialog>
    <!-- 分配平台弹框 end -->
    <!-- 分配角色弹框 start -->
    <el-dialog
      class="distributionUserDialog"
      @closed="distributionRolesDialogClosed"
      title="分配角色"
      :visible.sync="distributionRolesDialogVisible">
      <div class="content">
        <span class="title">选择角色：</span>
        <el-select v-model="selectedRoles" multiple placeholder="请选择要分配的角色">
          <el-option-group
            v-for="group in rolesOptions"
            :key="group.name"
            :label="group.name">
            <el-option
              v-for="item in group.roles"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-option-group>
        </el-select>
      </div>
      <div class="handleBtn">
        <el-button size="small" type="primary" @click="confirmDistributionRoles">确认</el-button>
        <el-button size="small" type="danger" @click="cancelDistributionRoles">取消</el-button>
      </div>
    </el-dialog>
    <!-- 分配角色弹框 end -->
    <!-- 分配资源弹框 start -->
    <el-dialog
      class="distributionUserResourcesDialog"
      @closed="distributionResourcesDialogClosed"
      title="分配资源"
      :visible.sync="distributionResourcesDialogVisible">
      <div class="content">
        <el-tree
          :data="resourcesOptions"
          show-checkbox
          @check="resourcesSelectChange"
          :check-strictly="true"
          node-key="id"
          :default-expand-all="true"
          :default-checked-keys="selectedResources"
          :props="resourcesDefaultProps">
        </el-tree>
      </div>
      <div class="handleBtn">
        <el-button type="primary" @click="confirmDistributionResources">确认</el-button>
        <el-button type="danger" @click="cancelDistributionResources">取消</el-button>
      </div>
    </el-dialog>
    <!-- 分配资源弹框 end -->
    <!-- 自定义属性弹框 start -->
    <el-dialog
      class="customAttribute"
      @closed="customAttributeDialogClosed"
      title="自定义字段"
      :before-close="handleAttrClose"
      :visible.sync="customAttributeDialogVisible">
      <div class="content">
        <div class="form-item">
          <div class="item">
            <span class="label">平台：</span>
            <el-select v-model="platformId" clearable placeholder="请选择平台">
              <el-option
                v-for="item in platformData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="label">
              <sup style="color:red">*</sup>
              属性名：
            </span>
            <el-input :disabled="editAttr" v-model="attrName" placeholder="请输入字段名" />
          </div>
          <div class="item">
            <span class="label">属性值：</span>
            <el-input v-model="attrValue" placeholder="请输入字段值" />
          </div>
        </div>
        <div class="btn-container">
          <el-button type="primary" @click="confirmCustomAttribute" size="small">
            保 存
          </el-button>
          <el-button type="danger" size="small" @click="handleRestAttribute">
            重 置
          </el-button>
        </div>
        <br />
        <el-table height="380" :data="tableData" style="width: 100%">
          <el-table-column prop="attrName" label="属性名" />
          <el-table-column prop="attrValue" label="属性值" />
          <el-table-column prop="platformName" label="平台" />
          <el-table-column label="操作">
            <template #default="scope">
              <el-button type="primary" size="mini" @click="handleEditUserAttr(scope)">编 辑</el-button>
              <el-button type="danger" size="mini" @click="handleRemoveUserAttr(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="handleBtn">
        <el-button size="small" type="primary" @click="confirmCustomAttribute">确认</el-button>
        <el-button size="small" type="danger" @click="cancelCustomAttribute">取消</el-button>
      </div> -->
    </el-dialog>
    <!-- 自定义属性弹框 end -->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import md5 from 'md5'
import BasePagination from '@/components/BasePagination'
// import vueJsonEditor from 'vue-json-editor'
export default {
  name: 'userMana',
  components: {
    BasePagination,
    // vueJsonEditor,
  },
  data () {
    return {
      platformData: [],
      platformId: null,
      // 修改密码 start
      modifyPasswordDialogVisible: false,
      newPassword: '',
      modifyPasswordId: '',
      // 修改密码 end
      showPassword: true,
      dialogType: '',
      // 新增用户参数start
      id: '',
      username: '',
      password: '',
      realname: '',
      gender: '',
      mobile: '',
      state: '',
      type: '',
      // 新增用户参数end
      // 性别配置项
      genderOptions: [
        {
          value: '男',
          label: '男',
        },
        {
          value: '女',
          label: '女',
        },
      ],
      // 账号状态配置项
      stateOptions: [
        {
          value: '1',
          label: '可用',
        },
        {
          value: '2',
          label: '冻结',
        },
      ],
      // 账号类型配置项
      typeOptions: [
        {
          value: '1',
          label: '管理员',
        },
        {
          value: '2',
          label: '一般用户',
        },
      ],
      addUserDialogVisible: false,
      addUserDialogTitle: '',
      searchUserName: '',
      // 列表数据
      listData: [],
      // 分页信息
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      // 分配平台
      distributionPlatformDialogVisible: false,
      allPlatformAndDeptOptions: [],
      hasPlatformAndDept: [],
      selectedPlatformAndDept: [],
      // platformsOptions: [],
      // selectedPlatform: [],
      // pids: '',
      uid: '',
      // 分配角色
      distributionRolesDialogVisible: false,
      rolesOptions: [],
      selectedRoles: [],
      // 分配资源
      distributionResourcesDialogVisible: false,
      resourcesOptions: [],
      selectedResources: [],
      reids: [],
      resourcesDefaultProps: {
        children: 'childs',
        label: 'name',
      },
      // 自定义属性
      customAttributeDialogVisible: false,
      attrName: '',
      attrValue: '',
      tableData: [],
      editAttr: false,

      // 业务系统链接角色的部门 Tree and id
      platformDept: [],
      platformPid: null,
    }
  },
  computed: {
    ...mapState({
      userType: 'type',
      loginPlatform: 'loginPlatform',
      userId: 'id',
      userDeptId: 'deptId',
    }),
    // platformList () {}
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             详情
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    search () {
      this.pageIndex = 1
      this.initListData()
    },
    /**
     * @description             获取平台树形数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    getPlatformTree () {
      this.$http.get('/api/platform/all')
        .then(res => {
          if (res.code === 'success') {
            this.platformData = res.data.list || []
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (row) {
      this.dialogType = 'detail'
      this.addUserDialogTitle = '用户详情'
      this.addUserDialogVisible = true
      this.id = row.id
      this.username = row.username
      this.realname = row.realname
      this.gender = row.gender
      this.mobile = row.mobile
      this.state = row.state
      this.type = row.type
    },
    /**
     * @description             修改密码按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    modifyPassword (row) {
      this.modifyPasswordDialogVisible = true
      this.modifyPasswordId = row.id
    },
    /**
     * @description             确认密码修改
     * @param {String}          用户id
     * @return {undefined}      无返回值
     */
    confirmModifyPassword () {
      if (this.newPassword) {
        this.$http.post('/api/user/modify-pwd/' + this.modifyPasswordId, {
          password: md5(this.newPassword),
        }).then(res => {
          if (res.code === 'success') {
            this.$notify({
              message: '密码修改成功！',
              type: 'success',
            })
            this.modifyPasswordDialogVisible = false
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      } else {
        this.$message({
          message: '密码不可为空！',
          type: 'error',
        })
      }
    },
    /**
     * @description             分配平台
     * @param {Object}          平台信息
     * @return {undefined}      无返回值
     */
    distributionPlatform (row) {
      this.distributionPlatformDialogVisible = true
      this.uid = row.id

      this.$http.get('/api/user/allocate', { uid: row.id }).then(res => {
        if (res.code === 'success') {
          const { allPlatform, hasPlatform } = res.data

          this.selectedPlatformAndDept = allPlatform.map(({ pid }) => {
            if (hasPlatform && hasPlatform.length) {
              const findData = hasPlatform.find(({ platformId }) => platformId === pid)

              if (findData) {
                const str = String(findData.deptId)
                const deptTreeIdArr = str.slice(1, str.length - 1).split('/').map(v => parseInt(v, 10))

                return {
                  pid: findData.platformId,
                  dept: deptTreeIdArr,
                }
              }

              return {
                pid: '',
                dept: [],
              }
            }

            return {
              pid: '',
              dept: [],
            }
          })

          const handleDepts = depts => {
            return depts.map(({ childs, ...rest }) => {
              if (childs && childs.length) {
                return { ...rest, childs: handleDepts(childs) }
              }
              return {
                ...rest,
              }
            })
          }

          this.allPlatformAndDeptOptions = allPlatform.map(({ depts, ...rest }) => {
            return { ...rest, depts: handleDepts(depts) }
          })

          this.hasPlatformAndDept = hasPlatform
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             平台及部门选择change事件
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    selectedPlatformAndDeptChange (val, index, pid) {
      this.selectedPlatformAndDept[index].pid = pid
    },
    /**
     * @description:  获取用户自定义属性列表
     * @param {*}
     * @return {*}
     */
    getUserAttrAll (params) {
      this.$http.post('/api/user/attr-all', params)
        .then(res => {
          if (res.code === 'success') {
            this.tableData = res.data.list.map(({ platformId, ...rest }) => {
              const findData = this.platformData.find(({ id }) => id === platformId) || {}
              return {
                ...rest,
                platformId,
                platformName: findData.name,
              }
            })
          }
        })
    },
    /**
     * @description             用户自定义属性
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    customAttribute (row) {
      this.customAttributeDialogVisible = true
      this.getUserAttrAll({ uid: row.id })
      this.uid = row.id
    },
    /**
     * @description             分配角色弹框
     * @param {Object}          角色信息
     * @return {undefined}      无返回值
     */
    distributionRoles (row) {
      this.distributionRolesDialogVisible = true
      this.uid = row.id
      this.getUserRoles(row.id)
    },
    /**
     * @description             获取全部角色和用户已有角色
     * @param {Object}          用户id
     * @return {undefined}      无返回值
     */
    getUserRoles (id) {
      this.$http.get('/api/user/role', {
        uid: id,
      }).then(res => {
        if (res.code === 'success') {
          let currentRoles = []
          res.data.hasRoles.map(k => {
            currentRoles.push(k.id)
          })
          this.rolesOptions = res.data.allRoles
          this.selectedRoles = currentRoles
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             获取用户资源信息
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    getUserResources (id) {
      this.$http.get('/api/user/resource', {
        uid: id,
      }).then(res => {
        if (res.code === 'success') {
          let allResources = []
          let currentResources = []
          let reids = []
          res.data.allResources.map(item => {
            allResources = allResources.concat(item.modules)
          })
          this.resourcesDataProcessing(allResources)
          res.data.hasResources.map(k => {
            currentResources.push(k.id + ',' + k.method)
            reids.push(k.id)
          })
          this.resourcesOptions = allResources
          this.selectedResources = currentResources
          this.reids = reids
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description:  编辑信息
     * @param {*}
     * @return {*}
     */
    handleEditUserAttr ({ row }) {
      this.attrName = row.attrName
      this.attrValue = row.attrValue
      this.platformId = row.platformId
      this.editAttr = true
    },
    /**
     * @description:  删除用户信息
     * @param {*} row
     * @return {*}
     */
    handleRemoveUserAttr ({ row }) {
      const { uid } = this
      this.$http.post('/api/user/attr-del', { uid, attrName: row.attrName })
        .then(() => {
          this.getUserAttrAll({ uid })
        })
    },
    /**
     * @description             资源数据处理
     * @param {Array}           资源数据
     * @return {undefined}      无返回值
     */
    resourcesDataProcessing (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type) {
          data[i].disabled = false
        } else {
          data[i].disabled = true
        }
        if (data[i].resources && data[i].resources.length) {
          data[i].resources.map(k => {
            data[i].childs.unshift({
              id: k.id + ',' + k.method,
              type: 'resources',
              name: k.method,
              disabled: false,
            })
          })
        }
        if (data[i].childs && data[i].childs.length > 0) {
          this.resourcesDataProcessing(data[i].childs)
        }
      }
    },
    /**
     * @description             分配资源弹框
     * @param {Object}          角色信息
     * @return {undefined}      无返回值
     */
    distributionResources (row) {
      this.uid = row.id
      this.distributionResourcesDialogVisible = true
      this.getUserResources(row.id)
    },
    /**
     * @description             确认平台分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmDistributionPlatform () {
      let pids = []
      this.selectedPlatformAndDept.map(k => {
        if (k.dept.length) {
          pids.push(k.pid + '-' + k.dept[k.dept.length - 1])
        }
      })
      if (this.uid) {
        this.$http.post('/api/user/allocate', {
          uid: this.uid,
          pids: pids.join(','),
        }).then(res => {
          if (res.code === 'success') {
            this.$message({
              message: '分配成功！',
              type: 'success',
            })
            this.distributionPlatformDialogVisible = false
            this.clearDistributionPlatformInfo()
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      }
    },
    /**
     * @description             确认角色分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmDistributionRoles () {
      this.$http.post('/api/user/role', {
        uid: this.uid,
        rids: this.selectedRoles.join(','),
      }).then(res => {
        if (res.code === 'success') {
          this.$message({
            type: 'success',
            message: '角色分配成功！',
          })
          this.cancelDistributionRoles()
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             确认资源分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmDistributionResources () {
      let reidsArr = []
      if (this.reids.length) {
        this.reids.map(k => {
          reidsArr.push(k.split(',')[0])
        })
      }
      this.$http.post('/api/user/resource', {
        uid: this.uid,
        reids: reidsArr.join(','),
      }).then(res => {
        if (res.code === 'success') {
          this.$message({
            type: 'success',
            message: '资源分配成功！',
          })
          this.distributionResourcesDialogVisible = false
          this.cancelDistributionResources()
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description:  重置属性
     * @param {*}
     * @return {*}
     */
    handleRestAttribute () {
      this.platformId = null
      this.attrValue = null
      this.attrName = null
      this.uid = null
      this.editAttr = false
    },
    handleAttrClose (done) {
      this.handleRestAttribute()
      done()
    },
    /**
     * @description             确认自定义属性
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmCustomAttribute () {
      const { platformId, attrValue, attrName, uid } = this

      if (!attrName) {
        this.$message({
          type: 'error',
          message: '请填写属性名！',
        })
        return
      }

      const params = {
        platformId: platformId || null,
        attrValue,
        attrName,
        uid,
      }

      this.$http.post('/api/user/attr', params)
        .then(res => {
          if (res.code === 'success') {
            this.getUserAttrAll({ uid })
          }
        })
      // if (this.attrName) {
      //   this.$http.post('/api/user/attr', {
      //     uid: this.uid,
      //     attrName: this.attrName,
      //     attrValue: this.attrValue,
      //   }).then(res => {
      //     if (res.code === 'success') {
      //       this.$message({
      //         type: 'success',
      //         message: '新增自定义字段成功！',
      //       })
      //       this.cancelCustomAttribute()
      //     } else {
      //       this.$message({
      //         message: res.msg,
      //         type: 'error',
      //       })
      //     }
      //   })
      // } else {
      //   this.$message({
      //     message: '字段名不能为空！',
      //     type: 'error',
      //   })
      // }
    },
    /**
     * @description             清空分配平台信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearDistributionPlatformInfo () {
      this.uid = ''
      this.allPlatformAndDeptOptions = []
      this.hasPlatformAndDept = []
      this.selectedPlatformAndDept = []
    },
    /**
     * @description             取消平台分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDistributionPlatform () {
      this.distributionPlatformDialogVisible = false
    },
    /**
     * @description             取消角色分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDistributionRoles () {
      this.distributionRolesDialogVisible = false
      this.rolesOptions = []
      this.selectedRoles = []
      this.uid = ''
    },
    /**
     * @description             取消资源分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDistributionResources () {
      this.distributionResourcesDialogVisible = false
      this.uid = ''
      this.resourcesOptions = []
      this.selectedResources = []
      this.reids = []
    },
    /**
     * @description             分配平台弹框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    distributionPlatformDialogClosed () {
      this.clearDistributionPlatformInfo()
    },
    /**
     * @description             分配角色弹框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    distributionRolesDialogClosed () {
      this.cancelDistributionRoles()
    },
    /**
     * @description             分配资源弹框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    distributionResourcesDialogClosed () {
      this.cancelDistributionResources()
    },
    /**
     * @description             自定义属性框关闭
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    customAttributeDialogClosed () {
      this.cancelCustomAttribute()
    },
    /**
     * @description             取消自定义属性
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelCustomAttribute () {
      this.customAttributeDialogVisible = false
      this.attrName = ''
      this.attrValue = ''
      this.uid = ''
    },
    /**
     * @description             分配用户选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    selectedPlatformChange (e) {
      this.pids = e.join(',')
    },
    /**
     * @description             资源选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    resourcesSelectChange (e1, e2) {
      let reids = []
      e2.checkedNodes.map(k => {
        reids.push(k.id)
      })
      this.reids = reids
    },
    /**
     * @description             分配角色选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    selectedRolesChange (e) {
      console.log(e)
    },
    /**
     * @description             修改用户按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    deleteUser (row) {
      let params = {
        ids: row.id,
      }
      this.$http.post('/api/user/delete', params)
        .then(res => {
          if (res.code === 'success') {
            this.$message({
              message: '删除成功！',
              type: 'success',
            })
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             新增用户按钮
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addUser () {
      this.dialogType = 'add'
      this.addUserDialogTitle = '新增用户'

      // 判断为非管理员用户及业务平台跳转
      if (this.userType !== '0') {
        this.getPlatformList().then(() => {
          this.addUserDialogVisible = true
        })
      } else {
        this.addUserDialogVisible = true
      }
    },
    /**
     * @description: 获取平台部门列表
     * @param {*} id
     * @return {*}
     */
    getPlatformList (id = null) {
      return this.$http.get('/api/user/allocate', { uid: id }).then(res => {
        if (res.code === 'success') {
          const { allPlatform, hasPlatform } = res.data

          const findAllPlatform = allPlatform.find(v => v.pid === this.loginPlatform.id)
          const findHasPlatform = hasPlatform.find(v => v.platformId === this.loginPlatform.id)
          console.log(findHasPlatform)

          if (findHasPlatform) {
            const hasPlatformArray = findHasPlatform.deptId.split('/').filter(v => v !== '')

            this.platformPid = Number(hasPlatformArray[hasPlatformArray.length - 1])
          } else {
            this.platformPid = this.userDeptId
          }

          /**
           * @description: 处理级联部门Tree数据 移除 depts为空的数据
           * @param {*}
           * @return {*}
           */
          const handlePlatformDept = depts => {
            return depts.map(({ childs, ...rest }) => {
              if (childs && childs.length) {
                return {
                  ...rest,
                  childs: handlePlatformDept(childs),
                }
              }

              return { ...rest }
            })
          }

          this.platformDept = findAllPlatform ? handlePlatformDept(findAllPlatform.depts) : []
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             修改用户按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    modifyUser (row) {
      this.dialogType = 'modify'
      this.addUserDialogTitle = '修改用户'
      this.showPassword = false
      this.password = ''
      this.id = row.id
      this.username = row.username
      this.realname = row.realname
      this.gender = row.gender
      this.mobile = row.mobile
      this.state = row.state
      this.type = row.type

      // 业务平台用户判断
      if (this.userType !== '0') {
        this.getPlatformList(row.id).then(() => {
          this.addUserDialogVisible = true
        })
      } else {
        this.addUserDialogVisible = true
      }
    },
    /**
     * @description             置空用户信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearUserInfo () {
      this.showPassword = true
      this.dialogType = ''
      this.id = ''
      this.username = ''
      this.password = ''
      this.realname = ''
      this.gender = ''
      this.mobile = ''
      this.state = ''
      this.type = ''
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addUserDialogVisible = false
    },
    /**
     * @description             取消修改密码
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelModifyPassword () {
      this.modifyPasswordDialogVisible = false
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (!this.username || !this.realname || !this.gender || !this.state || !this.type) {
        this.$message({
          type: 'warning',
          message: '请填写完整！',
        })
        return
      }
      let params = {
        username: this.username,
        realname: this.realname,
        gender: this.gender,
        mobile: this.mobile,
        state: this.state,
        type: this.type,
      }

      // 业务用户逻辑
      if (this.userType !== '0') {
        params.pids = `${this.loginPlatform.id}-${this.platformPid}`
      }

      if (this.dialogType === 'modify') {
        params.id = this.id
      } else if (this.dialogType === 'add') {
        params.password = md5(this.password)
      }

      this.$http.post('/api/user/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addUserDialogVisible = false
            this.$message({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    userDialogClosed () {
      this.clearUserInfo()
    },
    /**
     * @description             密码框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    modifyPasswordDialogClosed () {
      this.newPassword = ''
      this.modifyPasswordId = ''
    },
    /**
     * @description             初始化列表数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    initListData () {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        username: this.searchUserName,
      }
      this.$http.get('/api/user/list', params)
        .then(res => {
          if (res.code === 'success') {
            this.listData = res.data.list
            this.pageIndex = res.data.pageIndex
            this.total = res.data.total
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description: 当前页change事件
     * @param {Object} 事件对象
     * @return {undefined} 无返回值
     */
    currentChange (e) {
      this.pageIndex = e
      this.initListData()
    },
  },
  created () {
    this.getPlatformTree()
    this.setGlobalPlatformSelecter(false)
    this.initListData()
  },
}
</script>

<style lang="less" scoped>
  .userMana {
    width: 100%;
    height: 100%;

    .searchContainer {
      width: calc(100% - 40px);
      height: 50px;
      padding: 0 20px;
      position: relative;
      border-bottom: 1px solid rgb(241, 239, 239);

      .searchItem {
        display: inline-block;
        .searchTitle {
          color: #666;
        }
        .el-input {
          width: 200px;
        }
      }

      .searchButton {
        float: right;
      }
    }

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .list {
        /deep/.el-table {
          .el-table__body-wrapper {
            .el-table__body {
              tbody {
                tr {
                  td {
                    padding: 18px 0;
                  }
                }
              }
            }
          }
        }
        .abnormal {
          color: #F56C6C;
        }
        .normal {
          color: #67C23A;
        }
        .handle{
          span {
            display: inline-block;
            width: 40px;
            text-decoration: underline;
            cursor: pointer;
          }
          .detail {
            color: #3890f2;
          }
          .enable {
            color: #67C23A;
          }
          .disable {
            color: #F56C6C;
          }
          .modify{
            color: #3890f2;
          }
          .distribution {
            color: #3890f2;
            width: 70px;
          }
          .modifyPassword {
            color: #3890f2;
            width: 70px;
          }
          .delete{
            color: #F56C6C;
          }
        }
        .distributionHandle {
          span {
            display: inline-block;
            text-decoration: underline;
            cursor: pointer;
            color: #3890f2;
            margin-right: 10px;
          }
        }
      }

      .pagination {
        text-align: center;
        padding: 40px 0 0 0;
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 40%;
              margin: 30px 5%;
              .title {
                display: inline-block;
                width: 90px;
                text-align: right;
                .required {
                  display: inline-block;
                  width: 10px;
                  color: #F56C6C;
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
              .el-input {
                width: 220px;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }

    /deep/.modifyPasswordDialog {
      .el-dialog {
        width: 480px;
        height: 200px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            .el-input {
              width: 220px;
            }
            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 20px;
              right: 20px;
            }
          }
        }
      }
    }
    /deep/.distributionUserDialog {
      .el-dialog {
        width: 640px;
        height: 360px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 90%;
            position: relative;
            overflow-y: scroll;
            .el-select {
              width: 400px;
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
    .distributionPlatformDialog {
      /deep/.el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 90%;
            position: relative;
            overflow-y: scroll;
            .items {
              margin-bottom: 20px;
              .platformName {
                display: block;
                font-size: 16px;
                color: #333;
                line-height: 40px;
                .el-icon-s-platform {
                  color: #3890f2;
                }
              }
              .el-cascader {
                width: 600px;
              }
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
    /deep/.customAttribute {
      .el-dialog {
        width: 800px;
        height: 600px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            overflow-y: scroll;

            .form-item {
              display: flex;
              justify-content: space-between;
            }

            .btn-container {
              text-align: center;
              .el-button {
                width: 48%;
              }
            }
            .item {
              margin: 20px 0;
              .label {
                margin-left: 20px;
              }
              .el-input {
                width: 170px;
              }
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
    /deep/.distributionUserResourcesDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 90%;
            position: relative;
            overflow-y: scroll;
            .el-select {
              width: 400px;
            }
            .is-disabled {
              display: none !important;
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
  }
</style>
